import { useEffect, useRef } from 'react';
/**
 * Returns the value passed to the hook on previous render.
 *
 * Yields `undefined` on first render.
 *
 * @param value Value to yield on next render
 */
export function usePrevious(value) {
    const previous = useRef();
    useEffect(() => {
        previous.current = value;
    });
    return previous.current;
}
